


































































































































































































































































































































































































































import { Component, Prop, Vue, Watch } from 'vue-property-decorator';
import ChoiceScorerGroup from '@/views/ChoiceViewpointsScorer/ChoiceViewpointsScorerRecursiveGroup.vue';
import ViewpointCard from '@/components/common/ViewpointCard.vue';
import { getModule } from 'vuex-module-decorators';
import Viewpoints from '@/store/modules/Viewpoints';
import Scoring from '@/store/modules/Scoring';
import CompareViewpointDialog from '@/views/ChoiceViewpointsScorer/CompareViewpointDialog.vue';
import Decisions from '@/store/modules/Decisions';
import StorageImage from '@/components/common/StorageImage.vue';
import Choices, { Choice } from '@/store/modules/Choices';
import Apps from '@/store/modules/Apps';
import ScoringKeyEditorDialog from '@/components/scoring-key/ScoringKeyEditorDialog.vue';
import WorkspaceOptions from '@/store/modules/WorkspaceOptions';
import ViewpointChoiceScore from '@/components/scoring-input/ViewpointChoiceScore.vue';
import Colors from '@/utils/Colors';
import Sticky from 'vue-sticky-directive';
import Modelling from '@/store/modules/Modelling';
import _ from 'lodash';
import WorkspaceOptionValues from '@/utils/WorkspaceOptionValues';
import LinkShareDialog from '@/components/common/LinkShareDialog.vue';
import ViewpointNavigation from '@/components/navigation/ViewpointNavigation.vue';
import Users from '@/store/modules/Users';
import ChoiceViewpointCommonMenu from '@/components/common/ChoiceViewpointCommonMenu.vue';
import ViewpointVisibilitySelectorMenu from '@/components/workspace-options/ViewpointVisibilitySelectorMenu.vue'
import ViewpointFactorScore from '@/components/scoring-input/ViewpointFactorScore.vue';
import CreateChoiceDialog from "@/views/ChoiceCards/CreateChoiceDialog.vue";
import AutocreateViewpointDialog from '@/components/common/AutocreateViewpointDialog.vue';
import { NotificationEventBus } from '@/EventBus';
import { Viewpoint } from '@/api/model/Viewpoint';

const modellingModule = getModule(Modelling);
const viewpointsModule = getModule(Viewpoints);
const decisionsModule = getModule(Decisions);
const scoringModule = getModule(Scoring);
const choicesModule = getModule(Choices);
const workspaceOptionsModule = getModule(WorkspaceOptions);
const usersModule = getModule(Users);
const appsModule = getModule(Apps);

@Component({
    components: {
        ViewpointChoiceScore,
        ScoringKeyEditorDialog,
        StorageImage,
        ChoiceScorerGroup,
        ViewpointCard,
        CompareViewpointDialog,
        LinkShareDialog,
        ViewpointNavigation,
        ChoiceViewpointCommonMenu,
        ViewpointVisibilitySelectorMenu,
        ViewpointFactorScore,
        CreateChoiceDialog,
        AutocreateViewpointDialog
    },
    directives: {
        Sticky,
    },
})
export default class ChoiceScorer extends Vue {
    @Prop({ default: false, type: Boolean })
    hideTitle: boolean;

    @Prop({ default: false, type: Boolean })
    viewpointVisibility: boolean;

    @Prop({ default: true, type: Boolean })
    groupSummary: boolean;

    @Prop({ default: false, type: Boolean })
    embed: boolean;

    @Prop({ default: false, type: Boolean })
    appEmbed: boolean;

    @Prop({ default: false, type: Boolean })
    heroActive!: boolean

    private hoverTitle = false;
    private colors = Colors.COLORS;
    private menu = false;
    private viewpointList = [];
    private readonly widthOptions: any[] = WorkspaceOptionValues.WIDTH_OPTIONS;
    private createChoiceDialog = false;
    private creatingViewpoint = false;
    private createViewpointDialog = false;
    private sortOptions: any[] = [
        {
            id: 1,
            name: 'Alphabetical',
        },
        {
            id: 2,
            name: 'Overall Score - Low to High',
        },
        {
            id: 3,
            name: 'Overall Score - High to Low',
        },
        {
            id: 4,
            name: `${this.singularFactorLabel} - Low to High`,
        },
        {
            id: 5,
            name: `${this.singularFactorLabel} - High to Low`,
        },
    ];

    mounted() {
        this.viewpointList = _.cloneDeep(viewpointsModule.selectedViewpoints) || [];
        this.sortViewpointList()
    }

    get choiceSelectionMenu() {
        return appsModule.choiceSelectionMenu;
    }

    get isOwnerOrAdmin() {
        return decisionsModule.isAdminOrOwner;
    }

    get commentBottomHeight(){
        return workspaceOptionsModule.commentBottomHeight;
    }
    
    get commentVertical() {
        return workspaceOptionsModule.commentVertical;
    }

    get pinnedRight() {
        return workspaceOptionsModule.pinnedRight;
    }

    get cardContainerSize() {
        let commentHeight = 0;
        if (this.commentVertical && this.pinnedRight) {
            commentHeight = this.commentBottomHeight;
        } else if (!this.pinnedRight && this.appEmbed) {
            commentHeight = 40;
        } else {
            commentHeight = 0;
        }
        if (this.appEmbed) {
            if ( this.heroActive ) {
                return `min-height: calc(100vh - 165px - ${commentHeight}px); max-height: calc(100vh - 165px - ${commentHeight}px);`;
            } else {
                return `min-height: calc(100vh - 106px - ${commentHeight}px); max-height: calc(100vh - 106px - ${commentHeight}px);`;
            }
        } else if (this.embed) {
             return `max-height : calc(100vh - 32px - ${commentHeight}px); min-height:calc(100vh - 32px - ${commentHeight}px)`;
        } else {
             return `max-height : calc(100vh - 160px - ${commentHeight}px); min-height:calc(100vh - 160px - ${commentHeight}px)`;
        }
    }

     get mainContainerSize() {
        if(this.appEmbed){
            return 'min-height: calc(100vh - 38px); max-height: calc(100vh- 38px);';
        }else if(this.embed){
             return `max-height : calc(100vh); min-height:calc(100vh)`;
        }else{
             return `max-height : calc(100vh - 125px); min-height:calc(100vh - 125px)`;
        }
    }

    get viewpoints() {
        if (viewpointsModule.decisionViewpoints) {
            if (this.isOwnerOrAdmin) {
                let decisionViewpoints = _.cloneDeep(viewpointsModule.decisionViewpoints);
                return decisionViewpoints.sort((a: any, b: any) => {
                    if (a.name === b.name) return 1;
                    if (a.name){
                        return a.name.localeCompare(b.name);
                    }else{
                        return -1;
                    }
                });
            } else {
                let publicViewpoints = 
                _.cloneDeep(viewpointsModule.decisionViewpoints.filter(x => x.visibility === 'PUBLIC'));
                let createdViewpoints = 
                _.cloneDeep(viewpointsModule.decisionViewpoints.filter(x => x.ownerUserId === this.currentUserId));
                let userViewpoints = publicViewpoints.concat(createdViewpoints);
                if (userViewpoints && userViewpoints.length > 0) {
                    return userViewpoints.sort((a: any, b: any) => {
                        if (a.name === b.name) return 1;
                        if (a.name){
                            return a.name.localeCompare(b.name);
                        }else{
                            return -1;
                        }
                    });
                } else {
                    return userViewpoints;
                }
            }
        }
        return undefined;
    }

    private async createViewpoint(payload: any) {
        if (!this.selectedDecision) return;
        this.creatingViewpoint = true;
         NotificationEventBus.emitProcessingMessage();
        let newViewpoint = {
            viewpointId: '',
        };
        try {
            if (!this.selectedDecision) return;
            let newVp = {
                decisionId: this.selectedDecision.decisionId,
                name: payload.name,
                description: payload.description,
                addToList: true
            }
            newViewpoint =  await decisionsModule.createDecisionViewpoint(newVp);
            if(newViewpoint?.viewpointId != '' && workspaceOptionsModule.activeViewpointLists.length > 0) {
                decisionsModule.addViewpointToActiveLists(newViewpoint.viewpointId)
            }
            
            NotificationEventBus.emitSuccessMessage()
        } catch (err) {
            NotificationEventBus.emitFailedMessage(err)
        }
        this.createViewpointDialog = false;
        this.creatingViewpoint = false;
    }

    private async editAutocreateViewpoint(payload: Viewpoint) {
        await viewpointsModule.selectActiveViewpoint(payload.viewpointId);
        this.createViewpointDialog = false;
    }

    get sortOrder() {
        return workspaceOptionsModule.viewpointSort;
    }

    set sortOrder(sortId: number) {
        workspaceOptionsModule.setViewpointSort(sortId);
    }

    get appMenuName(){
        return appsModule.activeAppMenuName;
    }

    @Watch('sortOrder')
    onChangeSortOrder() {
        this.sortViewpointList();
    }

    get columnWidths() {
        if (Object.keys(workspaceOptionsModule.viewpointsColumnWidth).length === 0 || 
        Object.keys(workspaceOptionsModule.viewpointsColumnWidth).length < this.viewpointList.length) {
            workspaceOptionsModule.changeViewpointColumnWidth(this.columnWidth);
        }
        return workspaceOptionsModule.viewpointsColumnWidth;
    }

    get currentUserId() {
        if(usersModule.currentUserProfile){
            return usersModule.currentUserProfile.userId;
        }else{
            return null;
        }
    }

    get currentUserPermission() {
        if(decisionsModule.selectedDecisionUsers && this.currentUserId){
            return decisionsModule.selectedDecisionUsers[this.currentUserId].permissionAccess;
        }else{
            return null;
        }
        // console.log(decisionsModule.selectedDecisionUsers[this.currentUserId].permissionAccess)
    }


    get columnWidth() {
        return workspaceOptionsModule.viewpointColumnWidth;
    }

    get factorResources() {
        return modellingModule.publishedModelFactorResources;
    }

    get choices() {
        return choicesModule.choices;
    }

    get choicesList() {
        return choicesModule.choicesList;
    }

    get singularChoiceLabel() {
        return decisionsModule.singularChoiceLabel;
    }

    get pluralChoiceLabel() {
        return decisionsModule.pluralChoiceLabel;
    }

    get singularViewpointLabel() {
        return decisionsModule.singularViewpointLabel;
    }

    get pluralViewpointLabel() {
        return decisionsModule.pluralViewpointLabel;
    }

    get selectedChoice() {
        return choicesModule.selectedChoice;
    }

    get startingFactors() {
        if (workspaceOptionsModule.trimTopGroups) {
            let topFactor = 'M';
            return this.getTopGroup('M');
        } else {
            return ['M'];
        }
    }

    get viewpointFirstCol() {
        return workspaceOptionsModule.viewpointFirstCol;
    }

    set viewpointFirstCol(viewpointFirstCol: number) {
        workspaceOptionsModule.setViewpointFirstCol(viewpointFirstCol);
    }

    private getTopGroup(topId: string) {
        if (
            this.factorResources[topId].childrenIds &&
            this.factorResources[topId].childrenIds.length != 1
                ? true
                : 'groupTypeDefinition' in this.factorResources[this.factorResources[topId].childrenIds[0]] || this.factorResources[this.factorResources[topId].childrenIds[0]].type != 'FACTOR_GROUP'
        ) {
            return this.factorResources[topId].childrenIds;
        }

        if (
            this.factorResources[topId].childrenIds &&
            this.factorResources[topId].childrenIds.length === 1
        ) {
            return this.getTopGroup(this.factorResources[topId].childrenIds[0]);
        }
    }

    set selectedChoice(selectedChoice: any) {
        if (selectedChoice) {
            choicesModule.setSelectedChoiceId(selectedChoice.id);
        } else {
            choicesModule.setSelectedChoiceId(null);
        }
    }

    set columnWidth(columnWidth: number) {
        workspaceOptionsModule.changeViewpointColumnWidth(columnWidth);
    }

    private setSortOrder() {
        workspaceOptionsModule.changeViewpointSort(this.sortOrder);
        this.sortViewpointList();
    }

    get singularFactorLabel() {
        return decisionsModule.singularFactorLabel;
    }

    get pluralFactorLabel() {
        return decisionsModule.pluralFactorLabel;
    }

    private sortViewpointList() {
        switch (this.sortOrder) {
            case 1: {
                this.viewpointList.sort((a: any, b: any) => {
                    if (a.name === null || a.name === undefined) a.name = '';
                    if (b.name === null || b.name === undefined) b.name = '';
                    return a.name.localeCompare(b.name);
                });
                break;
            }

            case 2: {
                this.viewpointList.sort((a: any, b: any) => {
                    return this.getScore(a.viewpointId, 'M') - this.getScore(b.viewpointId, 'M');
                });
                break;
            }

            case 3: {
                this.viewpointList.sort((a: any, b: any) => {
                    return this.getScore(b.viewpointId, 'M') - this.getScore(a.viewpointId, 'M');
                });
                break;
            }

            case 4: {
                let selectedFactorId = workspaceOptionsModule.selectedPathItemId
                    ? workspaceOptionsModule.selectedPathItemId
                    : 'M';
                this.viewpointList.sort((a: any, b: any) => {
                    return (
                        this.getScore(a.viewpointId, selectedFactorId) -
                        this.getScore(b.viewpointId, selectedFactorId)
                    );
                });

                break;
            }

            case 5: {
                let selectedFactorId = workspaceOptionsModule.selectedPathItemId
                    ? workspaceOptionsModule.selectedPathItemId
                    : 'M';
                this.viewpointList.sort((a: any, b: any) => {
                    return (
                        this.getScore(b.viewpointId, selectedFactorId) -
                        this.getScore(a.viewpointId, selectedFactorId)
                    );
                });
                break;
            }
        }
    }

    get scoredChoices() {
        return scoringModule.viewpointScores;
    }

    get selectedDecision() {
        return decisionsModule.selectedDecision;
    }

    get selectedViewpoints() {
        return viewpointsModule.selectedViewpoints;
    }

    get selectedViewpoint() {
        if (viewpointsModule.activeViewpointId && viewpointsModule.decisionViewpointsMap) {
            return viewpointsModule.decisionViewpointsMap[viewpointsModule.activeViewpointId];
        }
    }

    get viewpointScoresLoaded() {
        if (this.selectedViewpoints) {
            return (
                this.selectedViewpoints
                    .map((v) => v.viewpointId)
                    .filter((vId) => !this.scoredChoices.hasOwnProperty(vId)).length === 0
            );
        }
        return false;
    }

    get modifiedViewpoints() {
        if (this.selectedViewpoints) {
            return this.selectedViewpoints.filter((vp: any) => vp.changed);
        }
    }

    get selectedFactor() {
        return workspaceOptionsModule.selectedPathItemId;
    }

    get loading() {
        return !this.selectedViewpoints || !this.scoredChoices || !this.viewpointScoresLoaded;
    }

    get viewpointScores() {
        return scoringModule.viewpointScores;
    }

    @Watch('selectedViewpoints')
    onChangeSelectedViewpoints(newVal: any) {
        this.viewpointList = _.cloneDeep(viewpointsModule.selectedViewpoints) || [];
        this.sortViewpointList();
    }

    private getViewpointChoiceFactorResource(vId: string, factorId: string) {
        if (
            viewpointsModule.viewpointChoiceFactorResource[vId] &&
            viewpointsModule.viewpointChoiceFactorResource[vId][this.selectedChoice.id]
        ) {
            return viewpointsModule.viewpointChoiceFactorResource[vId][this.selectedChoice.id][
                factorId
            ];
        }
        return null;
    }

    private getFactorScore(vId: string, factorId: string) {
        if (scoringModule.viewpointScores[vId]) {
            return scoringModule.viewpointScores[vId].choiceScores[this.selectedChoice.id]
                .choiceFactorScores[factorId];
        }
    }

    private getScore(vId: string, factorId: string) {
        if (
            this.getViewpointChoiceFactorResource(vId, factorId) &&
            this.getViewpointChoiceFactorResource(vId, factorId).score != null
        ) {
            return this.getViewpointChoiceFactorResource(vId, factorId).score;
        } else if (this.getFactorScore(vId, factorId)) {
            return this.getFactorScore(vId, factorId).score;
        }
        return 0;
    }

    @Watch('selectedFactor')
    private onSelectedFactorChange() {
        this.sortViewpointList();
    }

    @Watch('selectedChoice')
    private onSelectedChoiceChange() {
        this.sortViewpointList();
    }

    @Watch('viewpointScores', { deep: true })
    private changeFactorScores(newVal: any) {
        this.sortViewpointList();
    }

    private async createChoice(name: string) {
        let choice: Choice = {
            name: name,
            image: null,
            lastUpdatedTimestamp: null,
            creationTimestamp: null,
            visibility: 'ALL',
            ownerUserId: this.currentUserId
        }
        let newChoice = await choicesModule.createChoice(choice);
        this.createChoiceDialog = false;
        if(workspaceOptionsModule.activeChoiceLists.length > 0) {
            await decisionsModule.addChoiceToActiveLists(newChoice.id)
            await decisionsModule.getDecisionLists();
        }
        await choicesModule.fetchChoices();
        choicesModule.selectChoice(newChoice.id);
    }

    private editChoice(choice: Choice) {
        choicesModule.selectChoice(choice.id)
        this.createChoiceDialog = false;
    }
}
